import * as React from "react";
import { useEffect, useRef } from "react";
import "./movieItemViewStyles.css";
var LOAD_SETTLE_MS = 200;
export var MoviePoster = function (_a) {
    var url = _a.url, _b = _a.className, className = _b === void 0 ? "poster" : _b, activeProp = _a.active;
    var ref = useRef(null);
    var windowed = activeProp !== undefined;
    var active = activeProp !== null && activeProp !== void 0 ? activeProp : true;
    useEffect(function () {
        var el = ref.current;
        if (!el)
            return;
        if (!active || !url) {
            // Release the decoded texture when the poster leaves the active window.
            // On Cobalt the image cache holds every loaded background-image, so
            // clearing off-screen ones is what keeps GPU memory bounded.
            el.style.backgroundImage = "none";
            return;
        }
        if (!windowed) {
            el.style.backgroundImage = "url('" + url + "')";
            return;
        }
        var timer = setTimeout(function () {
            el.style.backgroundImage = "url('" + url + "')";
        }, LOAD_SETTLE_MS);
        return function () { return clearTimeout(timer); };
    }, [url, active, windowed]);
    return React.createElement("div", { ref: ref, className: className });
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/MoviePoster.tsx
// module id = 20
// module chunks = 1